import React from "react"
import { connect } from "~/redux/connect"
import { getModelTitle, getCurrentModelId, getParentId } from "~/stateGetter"

const mapStateToProps = (state) => {
    try {
        const modelId = getCurrentModelId(state),
              modelTitle = getModelTitle(state, modelId),
              parentModelId = modelId ? getParentId(state, modelId) : "",
              parentModelTitle = parentModelId ? getModelTitle(state, parentModelId) : "";
    
        return {
            modelTitle,
            parentModelTitle,        
        }
    } catch {
        return {
            modelTitle: "",
            parentModelTitle: "",
        }
    }

}


const defaultTitle = document.title;
const PageTitle = ({ modelTitle, parentModelTitle }) => {
    React.useEffect(() => {
        document.title = [ modelTitle, parentModelTitle, defaultTitle ].filter(Boolean).join(" | ")
    }, [ modelTitle, parentModelTitle, defaultTitle ]);
    return null
}


const mergeProps = (stateProps) => {
    return {
        ...stateProps
    }
}

export const PageTitleSync = connect(mapStateToProps, null, mergeProps)(PageTitle)